import React from 'react';
import PropTypes from 'prop-types';

import './EventProductGroup.sass';

import EventProduct from './EventProduct';
import FormatDate from '../dates/FormatDate';
import DateHint from '../dates/DateHint';

export default class EventProductGroup extends React.PureComponent {
  render() {
    const {presetId, date, events} = this.props;

    return (
      <div className="event-product-group">
        <div className="event-product-group__header">
          <span className="event-product-group__title">
            <FormatDate
              date={date}
              format="DD"
            />
            {' '}
            <small>
              <FormatDate
                date={date}
                format="MMM, dddd"
              />
            </small>
          </span>

          <span className="event-product-group__title event-product-group__title--hint">
            <DateHint date={date}/>
          </span>
        </div>

        <div className="event-product-group__list">
          {events.map(({id, occurrence, productVariant, optionValues, disabled}) => (
            <div className="event-product-group__list-item" key={`${id}_${occurrence}`}>
              <EventProduct
                presetId={presetId}
                eventId={id}
                occurrence={occurrence}
                productVariant={productVariant}
                options={optionValues}
                disabled={disabled}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/eventProducts/EventProductGroup.js